import api from '@pray/shared/utils/api';

export type BatchCreateSlotAssignmentSlot = {
  startDate: string;
  slotTime: string;
};

export type BatchCreateSlotAssignmentResultSlot = {
  id: string;
  artist_id: string;
  slot_time: string;
  recurrence_type: 'once';
  start_date: string;
  created_at: string;
};

type BatchCreateSlotAssignmentParams = {
  artistId: string;
  slots: BatchCreateSlotAssignmentSlot[];
};

/**
 * Grants one leader ownership of several free slots in a single atomic
 * request (PB-38029) — one independent, non-recurring assignment per slot.
 * The backend rejects the whole batch on any conflict (existing assignment,
 * scheduled content, duplicate slot, or a past start date).
 */
export async function batchCreatePrayRadioSlotAssignment({ artistId, slots }: BatchCreateSlotAssignmentParams) {
  if (!artistId) throw Error('Artist ID is required');
  if (!slots?.length) throw Error('At least one slot is required');

  const url = '/web/studio/pray-radio/slot-assignments/batch';
  const response = await api.executePostRequest(url, {
    artist_id: artistId,
    slots: slots.map((slot) => ({ start_date: slot.startDate, slot_time: slot.slotTime })),
  });

  return response.data;
}
